module.exports = __webpack_public_path__ + "static/media/CarlosVasquez.d04a5f32.png";